export const VISABLE_TYPE = {
    SHOW: 1,
    HIDE: 0
};

export const FREQUENCY_INTERVAL = {
    NO_LIMIT: 0,
    WEEKLY: 1,
    DAILY: 2
};

export const CLOSE_STYLE = {
    IMG: 0,
    BTN: 1
};
